<template>
  <section class="section container pt-0">
    <pool-tournaments-datatable />
  </section>
</template>

<script>
import PoolTournamentsDatatable from "./pool_tournaments_datatable/Index.vue";

export default {
  name: "PoolTournamentsIndex",
  components: { PoolTournamentsDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
